import { CurrencyCode } from '@/helpers/currency';

export enum DepositStep {
  SELECT_WALLET = 'select-wallet',
  PAYMENT_FORM = 'payment-form',
}

export const AMOUNT_VALUE_FIELD = 'amountValue';

export const HAS_SHOWN_LEAVE_DEPOSIT_MODAL = 'hasShownLeaveDepositModal';
export const TEN_MINUTES = 10 * 60 * 1000;

export enum HasModalShown {
  TRUE = 'true',
}

export const PRESET_AUD_TEST: Record<string, number[]> = {
  [CurrencyCode.AUD]: [25, 50, 100, 200, 500],
};

export const PRESETS: Record<string, number[]> = {
  [CurrencyCode.AUD]: [50, 100, 200, 500, 1000],
  [CurrencyCode.EUR]: [30, 50, 100, 200, 500],
  [CurrencyCode.CAD]: [40, 100, 200, 500, 1000],
  [CurrencyCode.USD]: [25, 50, 100, 200, 500],
  [CurrencyCode.NOK]: [300, 500, 1000, 2000, 5000],
  [CurrencyCode.NZD]: [40, 100, 200, 500, 1000],
  [CurrencyCode.ZAR]: [500, 1000, 2000, 5000, 10000],
  [CurrencyCode.BRL]: [100, 300, 500, 1000, 2000],
};

export const DEFAULT_AMOUNTS: Record<string, number> = {
  [CurrencyCode.AUD]: 50,
  [CurrencyCode.EUR]: 30,
  [CurrencyCode.CAD]: 50,
  [CurrencyCode.USD]: 50,
  [CurrencyCode.NOK]: 300,
  [CurrencyCode.NZD]: 50,
  [CurrencyCode.ZAR]: 500,
  [CurrencyCode.BRL]: 100,
};

export const BECOME_VIP_AMOUNTS: Record<string, number> = {
  [CurrencyCode.AUD]: 1000,
  [CurrencyCode.CAD]: 1000,
  [CurrencyCode.EUR]: 1000,
  [CurrencyCode.USD]: 1000,
  [CurrencyCode.NZD]: 1000,
  [CurrencyCode.NOK]: 10000,
  [CurrencyCode.USDT]: 1000,
  [CurrencyCode.BTC]: 0.037,
  [CurrencyCode.MBTC]: 0.037,
  [CurrencyCode.BCH]: 4.5,
  [CurrencyCode.LTC]: 15,
  [CurrencyCode.ETH]: 0.6,
  [CurrencyCode.DOG]: 15000,
  [CurrencyCode.JPY]: 150000,
  [CurrencyCode.BRL]: 2000,
  [CurrencyCode.ZAR]: 10000,
};
